// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-openseadragon {
    position: relative;
    width: 100%;
    margin: 0 auto;
}

.openseadragon-message {
    color: white
}

.aiiif-sources {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 130px;
    overflow: hidden;
}

.aiiif-sources:hover {
    overflow: auto;
}

.aiiif-sources img {
    width: 100%;
    display: block;
    margin: 10px 0;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/viewer/image/openSeadragon.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,eAAe;AACnB","sourcesContent":[".aiiif-openseadragon {\n    position: relative;\n    width: 100%;\n    margin: 0 auto;\n}\n\n.openseadragon-message {\n    color: white\n}\n\n.aiiif-sources {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 130px;\n    overflow: hidden;\n}\n\n.aiiif-sources:hover {\n    overflow: auto;\n}\n\n.aiiif-sources img {\n    width: 100%;\n    display: block;\n    margin: 10px 0;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
